module.exports = __webpack_public_path__ + "img/aquaqapp-logo.419754e1.png";